module.exports = __webpack_public_path__ + "img/consumer.a9d642c0.png";